<template>
  <div v-show="fragmentsLoaded" class="eptp_content">
    <Header />

    <ImportantMessagesModal
      :loading="loadingImportantMessage"
      :message="displayedImportantMessage"
      @read="markImportantMessageAsRead"
    />
  </div>
</template>

<script>
import Header from '../../components/Header';
import pageMixin from '../../mixins/page.mixin';

export default {
  name: 'Index',

  components: { Header },

  mixins: [pageMixin],

  mounted() {
    this.setupPage();
  },
};
</script>

<style>
@import '../../../assets/css/style.min.css';
@import '../../assets/index.css';
</style>
